import { AfterViewInit, Component, Injector, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';
import { IGenericSelectConfig } from '../../../interfaces/generic-select-config.interface';

@Component({
    selector: 'app-generic-select',
    templateUrl: './generic-select.component.html',
    styleUrls: ['./generic-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: GenericSelectComponent,
            multi: true,
        },
    ],
})
export class GenericSelectComponent extends FormControlComponent implements OnInit, AfterViewInit {
    @Input() public config: IGenericSelectConfig;
    @Input() public placeholder: string;
    @Input() public isValid = true;
    @Input() public readOnly: boolean;

    public inputId: string;
    public inputControl: FormControl;

    private ngControl: NgControl;

    constructor(private inj: Injector) {
        super();
    }

    ngOnInit(): void {
        this.inputControl = new FormControl({ value: null, disabled: this.readOnly });
        this.inputId = this.config.formGroupName;
    }

    ngAfterViewInit(): void {
        this.ngControl = this.inj.get(NgControl);
        this.ngControl.control.markAllAsTouched = () => {
            this.markAsTouched();
        };
    }

    public writeValue(obj: any): void {
        this.value = obj;
        this.inputControl.patchValue(obj);
    }

    public onValueChange(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.inputControl.value;
        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
        if (this.disabled) {
            this.inputControl.disable();
        } else {
            this.inputControl.enable();
        }
    }

    public compareWithId(c1: any, c2: any): boolean {
        return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2; // TODO - compare c1.value ou lieu de c1.id ? (car objet ISelectChoices n'a pas de id)
    }
}
